import { render, staticRenderFns } from "./StopsTable.vue?vue&type=template&id=b02a8960&scoped=true&"
import script from "./StopsTable.vue?vue&type=script&lang=js&"
export * from "./StopsTable.vue?vue&type=script&lang=js&"
import style0 from "./StopsTable.vue?vue&type=style&index=0&id=b02a8960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a8960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b02a8960')) {
      api.createRecord('b02a8960', component.options)
    } else {
      api.reload('b02a8960', component.options)
    }
    module.hot.accept("./StopsTable.vue?vue&type=template&id=b02a8960&scoped=true&", function () {
      api.rerender('b02a8960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/StopsTable.vue"
export default component.exports